import { Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import ReuploadApiResponseDialog from '../../../components/ReuploadDocuments/ReuploadApiResponseDialog';
import ReuploadDocumentsPageLayout from '../../../components/ReuploadDocuments/ReuploadDocumentsPageLayout';
import {
    ReuploadDocumentSlot,
    ReuploadDocumentsGrid,
    buildReuploadDocumentRemarks,
    buildReuploadStatusBarFromSlots,
    createReuploadUploadHandler,
    isDocFlagApproved,
    isDocFlagRejected,
    isReuploadSubmitDisabled,
    preserveReuploadDocumentValue,
    pickReuploadDocumentUrl,
    REUPLOAD_DOCUMENT_URL_KEYS,
    shouldShowReuploadDocumentSlot,
} from '../../../components/ReuploadDocuments/reuploadDocumentUi';
import { cfpBaseUrl } from '../../../network/urls';

const Newconnectionupdatedocuments = () => {
    const initialValues = {
        iv_applicant_cnic_document_front: null,
        iv_applicant_cnic_document_back: null,
        iv_property_documents: null,
        iv_near_by_bill: null,
        iv_affidavit_document: null,
        iv_neeca_noc_document: null,
        iv_any_other_document: null,
        iv_owner_cnic_document_front: null,
        iv_owner_cnic_document_back: null,
        iv_noc_owner: null,
        iv_resolution: null,
        iv_memo: null,
        iv_form29initial: null,
    };

    const [apiResponseDialog, setApiResponseDialog] = useState({
        open: false,
        type: 'success',
        message: '',
        documentRemarks: [],
    });
    const [submitCompleted, setSubmitCompleted] = useState(false);
    const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState('');
    const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState('');
    const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] = useState('');
    const [nearByBillDocumentThumbnail, setNearByBillDocumentThumbnail] = useState('');
    const [affidavitDocumentThumbnail, setAffidavitDocumentThumbnail] = useState('');
    const [neecaNOCDocumentThumbnail, setNeecaNOCDocumentThumbnail] = useState('');
    const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] = useState('');
    const [ownerCnicDocumentFrontThumbnail, setOwnerCnicDocumentFrontThumbnail] = useState('');
    const [ownerCnicDocumentBackThumbnail, setOwnerCnicDocumentBackThumbnail] = useState('');
    const [nocOwnerDocumentThumbnail, setNocOwnerDocumentThumbnail] = useState('');
    const [resolutionDocumentThumbnail, setResolutionDocumentThumbnail] = useState('');
    const [memorandumDocumentThumbnail, setMemorandumDocumentThumbnail] = useState('');
    const [form29DocumentThumbnail, setForm29DocumentThumbnail] = useState('');
    const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('');
    const [applicantCnicBackError, setApplicantCnicBackError] = useState('');
    const [propertyDocumentError, setPropertyDocumentError] = useState('');
    const [nearByBillError, setNearByBillError] = useState('');
    const [affidavitDocumentError, setAffidavitDocumentError] = useState('');
    const [neecaNOCDocumentError, setNeecaNOCDocumentError] = useState('');
    const [anyOtherDocumentError, setAnyOtherDocumentError] = useState('');
    const [ownerCnicFrontError, setOwnerCnicFrontError] = useState('');
    const [ownerCnicBackError, setOwnerCnicBackError] = useState('');
    const [nocError, setNocError] = useState('');
    const [bodError, setBodError] = useState('');
    const [memorandumError, setMemorandumError] = useState('');
    const [formError, setFormError] = useState('');
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [error, setError] = useState(false);
    const [cnicFrontReUploaded, setCnicFrontReUploaded] = useState(false);
    const [cnicBackReUploaded, setCnicBackReUploaded] = useState(false);
    const [propertyReUploaded, setPropertyReUploaded] = useState(false);
    const [nearByBillReUploaded, setNearByBillReUploaded] = useState(false);
    const [affidavitReUploaded, setAffidavitReUploaded] = useState(false);
    const [neecaNOCReUploaded, setNeecaNOCReUploaded] = useState(false);
    const [anyOtherReUploaded, setAnyOtherReUploaded] = useState(false);
    const [ownerCnicFrontReUploaded, setOwnerCnicFrontReUploaded] = useState(false);
    const [ownerCnicBackReUploaded, setOwnerCnicBackReUploaded] = useState(false);
    const [nocReUploaded, setNocReUploaded] = useState(false);
    const [resolutionReUploaded, setResolutionReUploaded] = useState(false);
    const [memorandumReUploaded, setMemorandumReUploaded] = useState(false);
    const [form29ReUploaded, setForm29ReUploaded] = useState(false);

    const { state } = useLocation();
    const { dialogRowData } = state || {};
    const { token } = useSelector((authState) => authState.auth);
    const navigate = useNavigate();

    const isTenant = dialogRowData?.applicantStatus === 'Tenant'
        || dialogRowData?.applicantStatus === 'tenant';
    const isIndustrial = dialogRowData?.connectionType === 'Industrial'
        || dialogRowData?.connectionType === 'industrial';
    const reuploadSources = [dialogRowData];

    useEffect(() => {
        setApplicantCnicDocumentFrontThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.cnicFront));
        setApplicantCnicDocumentBackThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.cnicBack));
        setPropertyDocumentsThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.property));
        setNearByBillDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.electricityBill));
        setAffidavitDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.affidavit));
        setNeecaNOCDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.neecaNoc));
        setAnyOtherDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.anyOther));
        setOwnerCnicDocumentFrontThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.ownerCnicFront));
        setOwnerCnicDocumentBackThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.ownerCnicBack));
        setNocOwnerDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.ownerNoc));
        setResolutionDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.resolution));
        setMemorandumDocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.memorandum));
        setForm29DocumentThumbnail(pickReuploadDocumentUrl(dialogRowData, REUPLOAD_DOCUMENT_URL_KEYS.form29));
    }, [dialogRowData]);

    const reuploadSlots = useMemo(() => {
        const slots = [];
        const addSlot = (show, flag, isReUploaded) => {
            if (show) {
                slots.push({ isRejected: isDocFlagRejected(flag), isReUploaded });
            }
        };

        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfApplicantCNICFront, flag: dialogRowData?.copyOfApplicantCNICFrontFlag, required: true }), dialogRowData?.copyOfApplicantCNICFrontFlag, cnicFrontReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfApplicantCNICBack, flag: dialogRowData?.copyOfApplicantCNICBackFlag, required: true }), dialogRowData?.copyOfApplicantCNICBackFlag, cnicBackReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.premisesDocument, flag: dialogRowData?.premisesDocumentFlag, required: true }), dialogRowData?.premisesDocumentFlag, propertyReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.scannedCopyOfNearByElectricityBill, flag: dialogRowData?.scannedCopyOfNearByElectricityBillFlag, required: true }), dialogRowData?.scannedCopyOfNearByElectricityBillFlag, nearByBillReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.affidavitDocument, flag: dialogRowData?.affidavitDocumentFlag }), dialogRowData?.affidavitDocumentFlag, affidavitReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.neecaNOCDocument, flag: dialogRowData?.neecaNOCDocumentFlag }), dialogRowData?.neecaNOCDocumentFlag, neecaNOCReUploaded);
        addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.anyOtherDocument, flag: dialogRowData?.anyOtherDocumentFlag }), dialogRowData?.anyOtherDocumentFlag, anyOtherReUploaded);

        if (isTenant) {
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfOwnerCNICFront, flag: dialogRowData?.copyOfOwnerCNICFrontFlag, required: true }), dialogRowData?.copyOfOwnerCNICFrontFlag, ownerCnicFrontReUploaded);
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfOwnerCNICBack, flag: dialogRowData?.copyOfOwnerCNICBackFlag, required: true }), dialogRowData?.copyOfOwnerCNICBackFlag, ownerCnicBackReUploaded);
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.ownerNOC, flag: dialogRowData?.ownerNOCFlag, required: true }), dialogRowData?.ownerNOCFlag, nocReUploaded);
        }

        if (isIndustrial) {
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.resolutionFormDesc, flag: dialogRowData?.resolutionFormDescFlag, required: true }), dialogRowData?.resolutionFormDescFlag, resolutionReUploaded);
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.certMemoDesc, flag: dialogRowData?.certMemoDescFlag, required: true }), dialogRowData?.certMemoDescFlag, memorandumReUploaded);
            addSlot(shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.certFormDesc, flag: dialogRowData?.certFormDescFlag, required: true }), dialogRowData?.certFormDescFlag, form29ReUploaded);
        }

        return slots;
    }, [
        dialogRowData,
        isTenant, isIndustrial,
        cnicFrontReUploaded, cnicBackReUploaded, propertyReUploaded, nearByBillReUploaded, affidavitReUploaded, neecaNOCReUploaded, anyOtherReUploaded,
        ownerCnicFrontReUploaded, ownerCnicBackReUploaded, nocReUploaded,
        resolutionReUploaded, memorandumReUploaded, form29ReUploaded,
    ]);

    const reuploadStatusBar = useMemo(
        () => buildReuploadStatusBarFromSlots(reuploadSlots),
        [reuploadSlots],
    );

    const disableSubmit = isReuploadSubmitDisabled(reuploadSlots, submitCompleted);

    const { handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({}),
        onSubmit: async () => {
            setViewBackdrop(true);

            let applicationProgressId = dialogRowData.applicationProgressId;
            if (applicationProgressId === 0) {
                applicationProgressId += 1;
            }

            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);

            const formdata = new FormData();
            formdata.append('applicationId', dialogRowData.applicationId);
            formdata.append('applicationProgressId', applicationProgressId);
            formdata.append('objectionStatus', 2);
            formdata.append('remarks', 'Documents Reuploaded.');
            formdata.append('ownerNOCFlag', '');
            formdata.append('premisesDocumentFlag', '');
            formdata.append('copyOfApplicantCNICFrontFlag', '');
            formdata.append('copyOfApplicantCNICBackFlag', '');
            formdata.append('scannedCopyOfNearByElectricityBillFlag', '');
            formdata.append('affidavitDocumentFlag', '');
            formdata.append('neecaNOCDocumentFlag', '');
            formdata.append('copyOfOwnerCNICFrontFlag', '');
            formdata.append('copyOfOwnerCNICBackFlag', '');
            formdata.append('resolutionFormDescFlag', '');
            formdata.append('certMemoDescFlag', '');
            formdata.append('certFormDescFlag', '');
            formdata.append('premisesDocument', preserveReuploadDocumentValue(propertyDocumentsThumbnail, dialogRowData?.premisesDocument));
            formdata.append('copyOfApplicantCNICFront', preserveReuploadDocumentValue(applicantCnicDocumentFrontThumbnail, dialogRowData?.copyOfApplicantCNICFront));
            formdata.append('copyOfApplicantCNICBack', preserveReuploadDocumentValue(applicantCnicDocumentBackThumbnail, dialogRowData?.copyOfApplicantCNICBack));
            formdata.append('ownerNOC', preserveReuploadDocumentValue(nocOwnerDocumentThumbnail, dialogRowData?.ownerNOC));
            formdata.append('copyOfOwnerCNICFront', preserveReuploadDocumentValue(ownerCnicDocumentFrontThumbnail, dialogRowData?.copyOfOwnerCNICFront));
            formdata.append('copyOfOwnerCNICBack', preserveReuploadDocumentValue(ownerCnicDocumentBackThumbnail, dialogRowData?.copyOfOwnerCNICBack));
            formdata.append('scannedCopyOfNearByElectricityBill', preserveReuploadDocumentValue(nearByBillDocumentThumbnail, dialogRowData?.scannedCopyOfNearByElectricityBill));
            formdata.append('affidavitDocument', preserveReuploadDocumentValue(affidavitDocumentThumbnail, dialogRowData?.affidavitDocument));
            formdata.append('neecaNOCDocument', preserveReuploadDocumentValue(neecaNOCDocumentThumbnail, dialogRowData?.neecaNOCDocument));
            formdata.append('resolutionFormDesc', preserveReuploadDocumentValue(resolutionDocumentThumbnail, dialogRowData?.resolutionFormDesc));
            formdata.append('certMemoDesc', preserveReuploadDocumentValue(memorandumDocumentThumbnail, dialogRowData?.certMemoDesc));
            formdata.append('certFormDesc', preserveReuploadDocumentValue(form29DocumentThumbnail, dialogRowData?.certFormDesc));
            formdata.append('anyOtherDocument', preserveReuploadDocumentValue(anyOtherDocumentThumbnail, dialogRowData?.anyOtherDocument));

            try {
                const response = await fetch(`${cfpBaseUrl}enc/updateENCDocuments`, {
                    method: 'POST',
                    headers: myHeaders,
                    body: formdata,
                    redirect: 'follow',
                });
                const result = await response.json();

                if (result.status === '200' || result.status === 200) {
                    setSubmitCompleted(true);
                    setApiResponseDialog({
                        open: true,
                        type: 'success',
                        message: result.message || 'Documents re-uploaded successfully.',
                        documentRemarks: buildReuploadDocumentRemarks({}, dialogRowData),
                    });
                } else {
                    setApiResponseDialog({
                        open: true,
                        type: 'error',
                        message: result.message || 'Something went wrong.',
                        documentRemarks: [],
                    });
                }
            } catch (submitError) {
                setApiResponseDialog({
                    open: true,
                    type: 'error',
                    message: 'Failed to re-upload documents.',
                    documentRemarks: [],
                });
            } finally {
                setViewBackdrop(false);
            }
        },
    });

    const makeUploadHandler = (setUploadError, setThumbnail, setReUploaded, filePrefix) =>
        createReuploadUploadHandler({
            handleChange,
            setUploadError,
            setThumbnail,
            setReUploaded,
            filePrefix,
        });

    const handleApiResponseDialogClose = () => {
        const wasSuccess = apiResponseDialog.type === 'success';
        setApiResponseDialog((prev) => ({ ...prev, open: false }));
        if (wasSuccess) {
            navigate('/new-connection-table', { state: { refreshNewConnectionList: true } });
        }
    };

    const documentSlotNodes = [];

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfApplicantCNICFront, flag: dialogRowData?.copyOfApplicantCNICFrontFlag, required: true })) {
        documentSlotNodes.push(
                            <ReuploadDocumentSlot
                                key="applicant-cnic-front"
                                label="CNIC Front"
                                thumbnail={applicantCnicDocumentFrontThumbnail}
                                documentSources={reuploadSources}
                                documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.cnicFront}
                                isApproved={isDocFlagApproved(dialogRowData?.copyOfApplicantCNICFrontFlag)}
                                isRejected={isDocFlagRejected(dialogRowData?.copyOfApplicantCNICFrontFlag)}
                                isReUploaded={cnicFrontReUploaded}
                                inputId="iv_applicant_cnic_document_front"
                                inputName="iv_applicant_cnic_document_front"
                                onUpload={makeUploadHandler(
                                    setApplicantCnicFrontError,
                                    setApplicantCnicDocumentFrontThumbnail,
                                    setCnicFrontReUploaded,
                                    'copyOfApplicantCNICFront',
                                )}
                                uploadError={applicantCnicFrontError}
                            />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfApplicantCNICBack, flag: dialogRowData?.copyOfApplicantCNICBackFlag, required: true })) {
        documentSlotNodes.push(
                            <ReuploadDocumentSlot
                                key="applicant-cnic-back"
                                label="CNIC Back"
                                thumbnail={applicantCnicDocumentBackThumbnail}
                                documentSources={reuploadSources}
                                documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.cnicBack}
                                isApproved={isDocFlagApproved(dialogRowData?.copyOfApplicantCNICBackFlag)}
                                isRejected={isDocFlagRejected(dialogRowData?.copyOfApplicantCNICBackFlag)}
                                isReUploaded={cnicBackReUploaded}
                                inputId="iv_applicant_cnic_document_back"
                                inputName="iv_applicant_cnic_document_back"
                                onUpload={makeUploadHandler(
                                    setApplicantCnicBackError,
                                    setApplicantCnicDocumentBackThumbnail,
                                    setCnicBackReUploaded,
                                    'copyOfApplicantCNICBack',
                                )}
                                uploadError={applicantCnicBackError}
                            />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.premisesDocument, flag: dialogRowData?.premisesDocumentFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="property-documents"
                        label="Property Documents"
                        thumbnail={propertyDocumentsThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.property}
                        isApproved={isDocFlagApproved(dialogRowData?.premisesDocumentFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.premisesDocumentFlag)}
                        isReUploaded={propertyReUploaded}
                        inputId="iv_property_documents"
                        inputName="iv_property_documents"
                        onUpload={makeUploadHandler(
                            setPropertyDocumentError,
                            setPropertyDocumentsThumbnail,
                            setPropertyReUploaded,
                            'copyOfPropertyDocument',
                        )}
                        uploadError={propertyDocumentError}
                    />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.scannedCopyOfNearByElectricityBill, flag: dialogRowData?.scannedCopyOfNearByElectricityBillFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="near-by-bill"
                        label="Near-by Electricity Bill"
                        thumbnail={nearByBillDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.electricityBill}
                        isApproved={isDocFlagApproved(dialogRowData?.scannedCopyOfNearByElectricityBillFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.scannedCopyOfNearByElectricityBillFlag)}
                        isReUploaded={nearByBillReUploaded}
                        inputId="iv_near_by_bill"
                        inputName="iv_near_by_bill"
                        onUpload={makeUploadHandler(
                            setNearByBillError,
                            setNearByBillDocumentThumbnail,
                            setNearByBillReUploaded,
                            'scannedCopyOfNearByElectricityBill',
                        )}
                        uploadError={nearByBillError}
                    />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.affidavitDocument, flag: dialogRowData?.affidavitDocumentFlag })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="affidavit-document"
                        label="Affidavit Document"
                        thumbnail={affidavitDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.affidavit}
                        isApproved={isDocFlagApproved(dialogRowData?.affidavitDocumentFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.affidavitDocumentFlag)}
                        isReUploaded={affidavitReUploaded}
                        inputId="iv_affidavit_document"
                        inputName="iv_affidavit_document"
                        onUpload={makeUploadHandler(
                            setAffidavitDocumentError,
                            setAffidavitDocumentThumbnail,
                            setAffidavitReUploaded,
                            'affidavitDocument',
                        )}
                        uploadError={affidavitDocumentError}
                    />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.neecaNOCDocument, flag: dialogRowData?.neecaNOCDocumentFlag })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="neeca-noc-document"
                        label="NEECA NOC Document"
                        thumbnail={neecaNOCDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.neecaNoc}
                        isApproved={isDocFlagApproved(dialogRowData?.neecaNOCDocumentFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.neecaNOCDocumentFlag)}
                        isReUploaded={neecaNOCReUploaded}
                        inputId="iv_neeca_noc_document"
                        inputName="iv_neeca_noc_document"
                        onUpload={makeUploadHandler(
                            setNeecaNOCDocumentError,
                            setNeecaNOCDocumentThumbnail,
                            setNeecaNOCReUploaded,
                            'neecaNOCDocument',
                        )}
                        uploadError={neecaNOCDocumentError}
                    />,
        );
    }

    if (shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.anyOtherDocument, flag: dialogRowData?.anyOtherDocumentFlag })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="any-other-document"
                        label="Any Other Document"
                        thumbnail={anyOtherDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.anyOther}
                        isApproved={isDocFlagApproved(dialogRowData?.anyOtherDocumentFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.anyOtherDocumentFlag)}
                        isReUploaded={anyOtherReUploaded}
                        inputId="iv_any_other_document"
                        inputName="iv_any_other_document"
                        onUpload={makeUploadHandler(
                            setAnyOtherDocumentError,
                            setAnyOtherDocumentThumbnail,
                            setAnyOtherReUploaded,
                            'anyOtherDocument',
                        )}
                        uploadError={anyOtherDocumentError}
                    />,
        );
    }

    if (isTenant && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfOwnerCNICFront, flag: dialogRowData?.copyOfOwnerCNICFrontFlag, required: true })) {
        documentSlotNodes.push(
                            <ReuploadDocumentSlot
                                key="owner-cnic-front"
                                label="Owner CNIC Front"
                                thumbnail={ownerCnicDocumentFrontThumbnail}
                                documentSources={reuploadSources}
                                documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.ownerCnicFront}
                                isApproved={isDocFlagApproved(dialogRowData?.copyOfOwnerCNICFrontFlag)}
                                isRejected={isDocFlagRejected(dialogRowData?.copyOfOwnerCNICFrontFlag)}
                                isReUploaded={ownerCnicFrontReUploaded}
                                inputId="iv_owner_cnic_document_front"
                                inputName="iv_owner_cnic_document_front"
                                onUpload={makeUploadHandler(
                                    setOwnerCnicFrontError,
                                    setOwnerCnicDocumentFrontThumbnail,
                                    setOwnerCnicFrontReUploaded,
                                    'copyOfOwnerCNIC',
                                )}
                                uploadError={ownerCnicFrontError}
                            />,
        );
    }

    if (isTenant && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.copyOfOwnerCNICBack, flag: dialogRowData?.copyOfOwnerCNICBackFlag, required: true })) {
        documentSlotNodes.push(
                            <ReuploadDocumentSlot
                                key="owner-cnic-back"
                                label="Owner CNIC Back"
                                thumbnail={ownerCnicDocumentBackThumbnail}
                                documentSources={reuploadSources}
                                documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.ownerCnicBack}
                                isApproved={isDocFlagApproved(dialogRowData?.copyOfOwnerCNICBackFlag)}
                                isRejected={isDocFlagRejected(dialogRowData?.copyOfOwnerCNICBackFlag)}
                                isReUploaded={ownerCnicBackReUploaded}
                                inputId="iv_owner_cnic_document_back"
                                inputName="iv_owner_cnic_document_back"
                                onUpload={makeUploadHandler(
                                    setOwnerCnicBackError,
                                    setOwnerCnicDocumentBackThumbnail,
                                    setOwnerCnicBackReUploaded,
                                    'copyOfOwnerCNIC',
                                )}
                                uploadError={ownerCnicBackError}
                            />,
        );
    }

    if (isTenant && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.ownerNOC, flag: dialogRowData?.ownerNOCFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="owner-noc"
                        label="NOC from Owner"
                        thumbnail={nocOwnerDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.ownerNoc}
                        isApproved={isDocFlagApproved(dialogRowData?.ownerNOCFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.ownerNOCFlag)}
                        isReUploaded={nocReUploaded}
                        inputId="iv_noc_owner"
                        inputName="iv_noc_owner"
                        onUpload={makeUploadHandler(
                            setNocError,
                            setNocOwnerDocumentThumbnail,
                            setNocReUploaded,
                            'ownerNOC',
                        )}
                        uploadError={nocError}
                    />,
        );
    }

    if (isIndustrial && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.resolutionFormDesc, flag: dialogRowData?.resolutionFormDescFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="resolution"
                        label="BoD's Resolution Form"
                        thumbnail={resolutionDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.resolution}
                        isApproved={isDocFlagApproved(dialogRowData?.resolutionFormDescFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.resolutionFormDescFlag)}
                        isReUploaded={resolutionReUploaded}
                        inputId="iv_resolution"
                        inputName="iv_resolution"
                        onUpload={makeUploadHandler(
                            setBodError,
                            setResolutionDocumentThumbnail,
                            setResolutionReUploaded,
                            'resolutionFormDesc',
                        )}
                        uploadError={bodError}
                    />,
        );
    }

    if (isIndustrial && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.certMemoDesc, flag: dialogRowData?.certMemoDescFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="memorandum"
                        label="Memorandum"
                        thumbnail={memorandumDocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.memorandum}
                        isApproved={isDocFlagApproved(dialogRowData?.certMemoDescFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.certMemoDescFlag)}
                        isReUploaded={memorandumReUploaded}
                        inputId="iv_memo"
                        inputName="iv_memo"
                        onUpload={makeUploadHandler(
                            setMemorandumError,
                            setMemorandumDocumentThumbnail,
                            setMemorandumReUploaded,
                            'certMemoDesc',
                        )}
                        uploadError={memorandumError}
                    />,
        );
    }

    if (isIndustrial && shouldShowReuploadDocumentSlot({ documentValue: dialogRowData?.certFormDesc, flag: dialogRowData?.certFormDescFlag, required: true })) {
        documentSlotNodes.push(
                    <ReuploadDocumentSlot
                        key="form29"
                        label="Form-29"
                        thumbnail={form29DocumentThumbnail}
                        documentSources={reuploadSources}
                        documentUrlKeys={REUPLOAD_DOCUMENT_URL_KEYS.form29}
                        isApproved={isDocFlagApproved(dialogRowData?.certFormDescFlag)}
                        isRejected={isDocFlagRejected(dialogRowData?.certFormDescFlag)}
                        isReUploaded={form29ReUploaded}
                        inputId="iv_form29initial"
                        inputName="iv_form29initial"
                        onUpload={makeUploadHandler(
                            setFormError,
                            setForm29DocumentThumbnail,
                            setForm29ReUploaded,
                            'certFormDesc',
                        )}
                        uploadError={formError}
                    />,
        );
    }

    const extraApplicationFields = (
        <>
            <Grid item xs={12} sm={6} md={4}>
                <div className="field-wrap">
                    <Typography className="fieldLabel">Connection Type</Typography>
                    <TextField
                        value={dialogRowData?.connectionType || ''}
                        disabled
                        fullWidth
                        size="small"
                        className="textInputField1"
                    />
                </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <div className="field-wrap">
                    <Typography className="fieldLabel">Applicant Status</Typography>
                    <TextField
                        value={dialogRowData?.applicantStatus || ''}
                        disabled
                        fullWidth
                        size="small"
                        className="textInputField1"
                    />
                </div>
            </Grid>
        </>
    );

    return (
        <>
            <ReuploadDocumentsPageLayout
                pageTitle="New Connection - Re-Upload Documents"
                statusBar={reuploadStatusBar}
                dialogRowData={dialogRowData}
                onSubmit={handleSubmit}
                onCancel={() => navigate('/new-connection-table')}
                submitDisabled={disableSubmit}
                viewBackdrop={viewBackdrop}
                error={error}
                onErrorClose={() => setError('')}
                extraApplicationFields={extraApplicationFields}
            >
                <ReuploadDocumentsGrid>
                    {documentSlotNodes}
                </ReuploadDocumentsGrid>
            </ReuploadDocumentsPageLayout>

            <ReuploadApiResponseDialog
                open={apiResponseDialog.open}
                type={apiResponseDialog.type}
                onClose={handleApiResponseDialogClose}
                message={apiResponseDialog.message}
                applicationId={dialogRowData?.applicationId}
                documentRemarks={apiResponseDialog.documentRemarks}
                errorTitle="Request Failed"
            />
        </>
    );
};

export default Newconnectionupdatedocuments;
